import { GetMRParam } from './helpers'
import { QueryParam } from '../../Helpers'
import { IModalRouteQueryParam } from './types'
import { MRAccessory } from './create.provider'

export interface IModalRouteParams<T extends Object, K extends string = string> {
  routeKey: K
  query?: T
}

class ModalRouteStackBase {
  [key: string]: any
  PopMdStack = (key?: string, data?: any) => {
    const qur = GetMRParam()
    if (key) {
      const index = qur.findIndex((x) => x === key)
      qur.splice(index, 1)
    } else {
      qur.pop()
    }
    QueryParam.Patch<IModalRouteQueryParam>({ md: qur }, data)
    MRAccessory.handler?.refresh()
  }
  PushMdStack = (key: string, data?: any) => {
    const qur = GetMRParam()
    qur.push(key)
    QueryParam.Patch<IModalRouteQueryParam>({ md: qur }, data)
    MRAccessory.handler?.refresh()
  }
  /** update January 10, 2025 */
  PopStack = <T extends Object, K extends string = string>(params?: Partial<IModalRouteParams<T, K>>) => {
    const qur = GetMRParam()
    if (params?.routeKey) {
      const index = qur.findIndex((x) => x === params.routeKey)
      qur.splice(index, 1)
    } else {
      qur.pop()
    }
    QueryParam.Patch<IModalRouteQueryParam>(Object.assign({}, params?.query, { md: qur }))
    MRAccessory.handler?.refresh()
  }
  /** update January 10, 2025 */
  PushStack = <T extends Object, K extends string = string>(params: IModalRouteParams<T, K>) => {
    const qur = GetMRParam()
    qur.push(params.routeKey)
    QueryParam.Patch(Object.assign({}, params.query, { md: qur }))
    MRAccessory.handler?.refresh()
  }
  Replace = <T extends Object, K extends string = string>(params: IModalRouteParams<T, K>) => {
    this.PopStack()
    this.PushStack(params)
  }
  GoBack = () => {
    window.history.back()
  }
  GoForward = () => {
    window.history.forward()
  }
}
const ModalRouteStack = new ModalRouteStackBase()
// ;(window as any).MRStack = MRStack
export default ModalRouteStack
